export default {
  setUserInfo(state,v){
    state.userInfo = v
  },
  setKeyword(state,v) {
    state.keyword = v
  },
};
